import { AppStrings } from "../../../../utils/constants/AppStrings";
import type { ActionsByCategoryAction } from "./ActionsByCategory/ActionsByCategory";

export const READ_ONLY_ACCESS_KEY = "read_only_access";

/**
 * The role-wide Read Only lock, expressed as an action row.
 *
 * It is a separate `read_only_access` field on the role payload rather than a
 * member of `available_actions`, but it is a switch in the same column, so it
 * renders as an ordinary row and the owning component maps the key back to the
 * field. It sorts into General (see `ACTION_CATEGORY_BY_KEY`), which leads the
 * category list.
 *
 * A function rather than a const because TCM overwrites `AppStrings` at
 * runtime — a module-level object would freeze the English defaults at import.
 */
export const readOnlyAccessRow = (): ActionsByCategoryAction => ({
  key: READ_ONLY_ACCESS_KEY,
  display_name: AppStrings.READ_ONLY_ACCESS_TOGGLE,
  info: AppStrings.READ_ONLY_ACCESS_TOGGLE_INFO,
});
